import { useEffect } from 'react'
import { useChannelStore } from '@/store/channel'
import { initConsentDefault } from '@/lib/consentMode'

export default function GoogleTagManager() {
  const gtmId = useChannelStore((state) => state.googleTagManagerId)

  useEffect(() => {
    if (!gtmId) return

    // Consent Mode v2: set default (denied) signals before GTM/GA loads
    initConsentDefault()

    // Standard GTM script
    const script = document.createElement('script')
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
    `
    document.head.appendChild(script)

    // Standard GTM noscript
    const noscript = document.createElement('noscript')
    const iframe = document.createElement('iframe')
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`
    iframe.height = '0'
    iframe.width = '0'
    iframe.style.display = 'none'
    iframe.style.visibility = 'hidden'
    noscript.appendChild(iframe)
    document.body.insertBefore(noscript, document.body.firstChild)

    return () => {
      // Cleanup if needed (though usually GTM stays for the whole session)
      document.head.removeChild(script)
      if (document.body.contains(noscript)) {
        document.body.removeChild(noscript)
      }
    }
  }, [gtmId])

  return null
}
